(function () {
  /**
   * @ngdoc component
   * @name abxCreateButton
   *
   * @description
   * A button for use with the mobile footer that displays options to
   * create a new SR or WO when clicked
   */
  angular
    .module("akitabox.mobile.components.create-buttons", [
      "akitabox.core.services.identity",
      "akitabox.core.services.organization",
      "akitabox.core.services.redirect",
      "akitabox.core.services.user",
      "akitabox.core.toast",
    ])
    .controller("CreateNavButtons", CreateNavButtonsController)
    .component("abxCreateNavButtons", {
      bindings: {
        createMenuOpen: "<abxCreateMenuOpen",
        navigationMenuOpen: "<abxNavigationMenuOpen",
        closeOverlay: "<abxCloseOverlay",
        addWorkOrder: "<abxAddWorkOrder",
        addServiceRequest: "<abxAddServiceRequest",
      },
      controller: CreateNavButtonsController,
      controllerAs: "vm",
      templateUrl:
        "app/mobile/components/create-nav-buttons/create-nav-buttons.component.html",
    });

  /** @ngInject */
  function CreateNavButtonsController(
    // Angular
    $location,
    // Third-party
    $state,
    // Services
    IdentityService,
    OrganizationService,
    RedirectService,
    ToastService,
    UserService
  ) {
    var self = this;

    // Attributes
    self.organization = OrganizationService.getCurrent();
    self.account = null;
    self.permissions = getPermissions();

    // Functions
    self.goToDesktop = goToDesktop;
    self.goToMyWorkOrders = goToMyWorkOrders;
    self.goToNewServiceRequests = goToNewServiceRequests;

    init();

    function init() {
      // Fetch Account
      IdentityService.getCurrent()
        .then(function (account) {
          self.loadingAccount = false;
          self.account = account;
        })
        .then(function () {
          if (self.orgLevelMobile) {
            self.organization = OrganizationService.getCurrent();
          }
        })
        .catch(ToastService.showError);
    }

    function getPermissions() {
      var permissions = UserService.getPermissions();
      return {
        canAddRequest: permissions.request.create,
        canAddWorkOrder: permissions.task.create,
      };
    }

    function goToNewServiceRequests() {
      $state.go("app.serviceRequests.new");
    }

    function goToMyWorkOrders() {
      $state.go(
        "app.workOrders.my",
        {
          accountId: self.account._id,
          status: "open",
        },
        {
          reload: true,
        }
      );
    }

    function goToDesktop() {
      RedirectService.redirectToDesktop($location.path());
    }
  }
})();
